import { Pipe, PipeTransform } from '@angular/core';

const INTERNATIONAL_PREFIX_REGEX = /^(?:\+|00)(\d{1,3})(\d*)$/;

function formatNationalPhoneNumber(value: string): string {
  if (!value) {
    return '';
  }

  if (value.length === 10) {
    return value.match(/.{1,2}/g)?.join(' ') ?? value;
  }

  let formatted = value.charAt(0);
  for (let index = 1; index < value.length; index += 2) {
    formatted += ' ' + value.substring(index, index + 2);
  }

  return formatted.trim();
}

function extractInternationalParts(
  raw: string,
): { countryCode: string; nationalNumber: string } | null {
  if (raw.startsWith('+33')) {
    return { countryCode: '33', nationalNumber: raw.slice(3) };
  }

  if (raw.startsWith('0033')) {
    return { countryCode: '33', nationalNumber: raw.slice(4) };
  }

  const internationalMatch = raw.match(INTERNATIONAL_PREFIX_REGEX);
  if (!internationalMatch) {
    return null;
  }

  return {
    countryCode: internationalMatch[1],
    nationalNumber: internationalMatch[2],
  };
}

function formatPhoneNumber(value: string): string {
  if (!value) {
    return '';
  }

  const raw = value.trim().replace(/[^\d+]+/g, '');
  const internationalParts = extractInternationalParts(raw);

  if (internationalParts) {
    return `(+${internationalParts.countryCode})${formatNationalPhoneNumber(internationalParts.nationalNumber)}`;
  }

  const normalized = raw.replace(/\D+/g, '');
  return formatNationalPhoneNumber(normalized);
}

@Pipe({
  name: 'phoneNumber',
  standalone: true,
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }

    return formatPhoneNumber(String(value));
  }
}
